export function replaceNewLineHtml(text: string | null | undefined): string{
    if(text){
        return text.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />');
    }
    return "";
}